import { formatPhone, formatPhoneLink } from '../../../Utility/phoneNumberFormat';
import { makeCall } from '../../../Utility/makeCallText';
import { usdFormat } from '../../../Utility/usdFormat';
import logo from '../../../assets/Hirschnow.png';
// import ViewShot from 'react-native-view-shot';
// import ViewShotRef from 'react-native-view-shot';
import { useEffect, useRef, useState } from 'react';
// import { ShareBid } from './ShareBid';
import { toTitleCase } from '../../../Utility/toTitleCase';
import { sendEmail } from '../../../Utility/sendEmail';
import Loading from '../../../Components/Loading';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { getBidDetail } from './BidSlice';
import { BidProduct } from '../../../Types/Bid';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { useLocation, useNavigate } from 'react-router-dom';

const BidDetails = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const item = location.state?.item;
    const data = useAppSelector(getBidDetail);
    const loading = useAppSelector((state) => state.bids.loading);
    const error = useAppSelector((state) => state.bids.error);
    const ref = useRef(null);
    const imagesLoadedRef = useRef(0);
    const [imagesReady, setImagesReady] = useState(false);
        
    if (!data.length) {
        return <Loading />;
    }

    const photoUri = data?.[0].products?.details?.[0]?.IMAGES?.[0]?.PHOTO;
    const products = data?.[0].products ?? [];

    const totalImages = products.filter((p: BidProduct) => {
        const uri = p?.details?.[0]?.IMAGES?.[0]?.PHOTO;
        return uri && !uri.includes('NULL');
    }).length;

    const bidTotal = products.reduce((accumulator: number, currentProduct: BidProduct) => {
        const subTotal = accumulator + Number(currentProduct.price * currentProduct.qty)
        return subTotal + Number(item.taxAmt ?? 0)
    }, 0)

    // const CaptureAndShare = async () => {
    //     if (!ref.current?.capture) return;

    //     try {
    //         const uri = await ref.current.capture();

    //         // await ShareBid({ item, uri, template: template ?? 'Default' })

    //     } catch (err: any) {
    //         console.error(err.message);
    //     }
    // };

    // useEffect(() => {
    //     if (!shareOnOpen) return;

    //     if (shareOnOpen) {
    //         if (!loading && data.length && !imagesReady) {
    //             setTimeout(() => {
    //                 CaptureAndShare();
    //             }, 500);
    //         }
    //     }
    // }, [shareOnOpen, loading, imagesReady]);

    if (!item || item === null || Object.keys(item).length === 0) {
        return (
            <div>
                <Loading />
            </div>
        )
    };

    if (!data.length) {
        return (
            <div style={{ flex: 1 }}>
                <Loading />
            </div>
        )
    };

    return (
        <div style={{ padding: 10 }}>
            {error && <span style={{ color: 'red' }}>Error: {error}</span>}
            {loading
                ? (<Loading />)
                : (
                    <>
                        <Row 
                            key={item.quoteID}
                            style={{ paddingInline: 20 }}
                        >
                            <Col xs={12} md={6} lg={6}>
                                <Card>
                                    <CardHeader style={{ background: 'white' }}>
                                        <span className='headerText'>Bid Details</span>
                                    </CardHeader>
                                    <CardBody className='d-flex text-start gap-3'>
                                        <div>
                                            <span className='fw-bold d-block'>Bid ID:</span>
                                            <span className='fw-bold d-block'>Customer:</span>
                                            <span className='fw-bold d-block'>Created:</span>
                                            <span className='fw-bold d-block'>Expires:</span>
                                            {item.job && <span className='fw-bold d-block'>Job:</span>}
                                            {item.note && <span className='fw-bold d-block'>Note:</span>}
                                            <span className='fw-bold d-block'>Order:</span>
                                            {Number(item.taxAmt) > 0 &&
                                                <span className='fw-bold d-block'>Tax:</span>
                                            }
                                            <span className='fw-bold d-block'>Branch:</span>
                                            <span className='fw-bold d-block'>Bid Amount:</span>
                                        </div>
                                        <div>
                                            <span className='itemDescription d-block'>{item.quoteID}</span>
                                            <span className='itemDescription d-block'>{item.billName}</span>
                                            <span className='itemDescription d-block'>{item.created}</span>
                                            <span className='itemDescription d-block'>{item.expires}</span>
                                            {item.job && <span className='itemDescription d-block'>{item.job}</span>}
                                            {item.note && <span className='itemDescription d-block'>{item.note}</span>}
                                            {item.orders.length > 0 
                                                ? <span
                                                    className='itemDescription d-block' 
                                                    style={{ color: '#0000FF' }}
                                                >
                                                    {item.orders[0].order}
                                                </span>
                                                : <span className='itemDescription d-block'>No Orders Yet</span>
                                            }
                                            {Number(item.taxAmt) > 0 &&
                                                <span className='itemDescription d-block'>{usdFormat.format(item.taxAmt)}</span>
                                            }
                                            <span className='itemDescription d-block'>{item.branchID}</span>
                                            <span className='itemDescription d-block'>{usdFormat.format(bidTotal)}</span>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col xs={12} md={6} lg={6}>
                                <Card>
                                    <CardHeader style={{ background: 'white' }}>
                                        <span className='headerText'>Contact Information</span>
                                    </CardHeader>
                                    <CardBody className='text-start d-flex gap-2'>
                                        <div style={{ flexDirection: 'row' }}>
                                            <span style={{ fontWeight: 'bold', display: 'block'}}>Name: </span>
                                            <span style={{ fontWeight: 'bold', display: 'block'}}>Phone: </span>
                                            <span style={{ fontWeight: 'bold', display: 'block'}}>Email: </span>
                                        </div>
                                        <div style={{ flexDirection: 'row' }}>
                                            <span className='d-block'>{toTitleCase(item.contactName)}</span>
                                            <a 
                                                onClick={() => makeCall(formatPhoneLink(item.contactPhone))}
                                                className='d-block'
                                                style={{ color: '#1a73e8', textDecoration: 'underline', cursor: 'pointer' }}
                                            >
                                                {formatPhone(item.contactPhone)} 
                                            </a>
                                            <a
                                                onClick={() => sendEmail(item.contactEmail)}
                                                className='d-block'
                                                style={{ color: '#1a73e8', textDecoration: 'underline', cursor: 'pointer' }}
                                            >
                                                {item.contactEmail}
                                            </a>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col xs={12} md={12} lg={6}>
                                <Card className='mt-3'>
                                    <CardHeader style={{ background: 'white' }}>
                                        <span className='headerText'>Shipping & Billing</span>
                                    </CardHeader>
                                    <CardBody 
                                        style={{ justifyContent: 'space-around' }}
                                        className='text-start d-flex gap-5'
                                    >
                                        <div>
                                            <span style={{ fontWeight: 'bold', display: 'block' }}>Ship To:</span>
                                            <span className='d-block'>{item.shipName}</span>
                                            <span className='d-block'>{item.shipAddress1}</span>
                                            {item.shipAddress2 && 
                                            <span className='d-block'>{item.shipAddress2}</span>}
                                            <span className='d-block'>{`${item.shipCity} ${item.shipState}, ${item.shipZip}`}</span>
                                            <a 
                                                onClick={() => makeCall(formatPhoneLink(item.shipPhone))}
                                                style={{ color: '#1a73e8', textDecoration: 'underline', cursor: 'pointer' }}
                                            >
                                                {formatPhone(item.shipPhone)}
                                            </a>
                                        </div>
                                        <div>
                                            <span style={{ fontWeight: 'bold', display: 'block' }}>Bill To:</span>
                                            <span className='d-block'>{item.billName}</span>
                                            <span className='d-block'>{item.billAddress1}</span>
                                            {item.billAddress2 && 
                                            <span className='d-block'>{item.billAddress2}</span>}
                                            <span className='d-block'>{`${item.billCity} ${item.billState}, ${item.billZip}`}</span>
                                            <a 
                                                onClick={() => makeCall(formatPhoneLink(item.billPhone))}
                                                style={{ color: '#1a73e8', textDecoration: 'underline', cursor: 'pointer' }}
                                            >
                                                {formatPhone(item.billPhone)}
                                            </a>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row style={{ paddingInline: 20 }}>
                            <Col>
                                <Card className='mt-3'>
                                    <CardHeader style={{ background: 'white' }}>
                                        <span className='headerText'>Products</span>
                                    </CardHeader>
                                    <CardBody>
                                        {data[0].products.length > 0 ? 
                                            data[0].products.map((item: BidProduct) => {
                                                const photoUri = item?.details?.[0]?.IMAGES?.[0]?.PHOTO;
                                                
                                                return (
                                                    <Card
                                                        key={item.sku}
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => navigate(`/ProductDetail/${item.product}`, { state: { item } })}
                                                    >
                                                        <CardBody className='d-flex text-start'>
                                                            <div style={{ alignSelf: 'center', marginRight: 20 }}>
                                                                {!photoUri || photoUri.includes('NULL') ? (
                                                                    <img 
                                                                        style={{ 
                                                                            justifyContent: 'center', 
                                                                            height: 75, 
                                                                            width: 100 
                                                                        }}
                                                                        src={logo}
                                                                    />
                                                                ) : (
                                                                    <img 
                                                                        style={{ 
                                                                            justifyContent: 'center', 
                                                                            height: 75, 
                                                                            width: 100 
                                                                        }}
                                                                        src={ photoUri }
                                                                        // PlaceholderContent={<ActivityIndicator size='large'/>}
                                                                        // onLoadEnd={() => {
                                                                        //     imagesLoadedRef.current += 1;

                                                                        //     if (imagesLoadedRef.current >= totalImages) {
                                                                        //         setImagesReady(true);
                                                                        //     }
                                                                        // }}
                                                                    />
                                                                )}
                                                            </div>
                                                            <div style={{ marginInlineEnd: 5 }}>
                                                                <span className='itemName d-block'>Product:</span>
                                                                <span className='itemName d-block'>SKU:</span>
                                                                <span className='itemName d-block'>Qty:</span>
                                                                <span className='itemName d-block'>Price:</span>
                                                            </div>
                                                            <div>
                                                                <span className='itemDescription d-block'>{item.product}</span>
                                                                <span className='itemDescription d-block'>{item.sku}</span>
                                                                <span className='itemDescription d-block'>{item.qty}</span>
                                                                <span className='itemDescription d-block'>{usdFormat.format(item.price)}</span>
                                                            </div>
                                                        </CardBody>
                                                    </Card>
                                                )
                                            })
                                            : <span>No Products</span>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>

                        </Row>
                    </>
                )
            }
        </div>
    )
}

// const styles = StyleSheet.create({        
//     container: {
//         justifyContent: 'flex-start',
//         // paddingHorizontal: 16,
//         padding: 5,
//         backgroundColor: '#f9f9f9',
//         marginBottom: 8,
//         borderRadius: 5,
//         shadowColor: '#000',
//         shadowOffset: { width: 0, height: 1 },
//         shadowOpacity: 0.2,
//         shadowRadius: 1.41,
//         elevation: 2,
//         width: '100%'
//     },
//     listContainer: {
//         // flex: 1,
//         // flexGrow: 1.5,
//         // flexShrink: 1.5,
//         flexDirection: 'row',
//         justifyContent: 'flex-start',
//         // paddingHorizontal: 16,
//         paddingTop: 5,
//         backgroundColor: 'white',
//         marginBottom: 8,
//         borderRadius: 5,
//         shadowColor: '#000',
//         shadowOffset: { width: 0, height: 1 },
//         shadowOpacity: 0.2,
//         shadowRadius: 1.41,
//         // borderBottomWidth: .2,
//         elevation: 2,
//         width: '100%'
//     },
//     itemContainer: {
//         flexDirection: 'row',
//         justifyContent: 'flex-start',
//         alignItems: 'center',
//         backgroundColor: '#f9f9f9',
//         paddingHorizontal: 16,
//         paddingTop: 5,
//         marginBottom: 8,
//         borderRadius: 5,
//         shadowColor: '#000',
//         shadowOffset: { width: 0, height: 1 },
//         shadowOpacity: 0.2,
//         shadowRadius: 1.41,
//         elevation: 2,
//         width: '100%'
//     },
//     headerText: {
//         fontSize: 16,
//         fontWeight: 'bold',
//         marginVertical: 5,
//         textAlign: 'center',
//         alignSelf: 'center'
//     },
//     itemName: {
//         fontWeight: 'bold',
//         marginVertical: 5,
//         paddingHorizontal: 5,
//     },
//     itemDescription: {
//         marginVertical: 5,
//         paddingHorizontal: 5,
//     },
//     tinyLogo: {
//         justifyContent: 'center',
//         height: 75,
//         width: 100
//     }
// });

export default BidDetails;
